import { apiRequest, getSluiceUrl } from "../../../apiHelper/apiRequest";
import { serialize } from "../../../helpers/helpers";


const list = async (params) => {
	return apiRequest(
                        "/road-to-airport/types/list?" + serialize(params),
                        {
                            method: "GET"
                        },
                        'ptp_client'
                    );
}


const add = async ( params ) => {
    let add_response = await apiRequest(
                                        "/road-to-airport/types/add",
                                        {
                                            method: "POST",
                                            body: params
                                        },
                                        'ptp_client'
                                    );
    if ( typeof(add_response.id) !== 'undefined' && add_response.id )
        return add_response.id;
    else
        return 0;
}


const update = async ( params ) => {
    let add_response = await apiRequest(
                                        "/road-to-airport/types/update",
                                        {
                                            method: "PUT",
                                            body: params
                                        },
                                        'ptp_client'
                                    );
    if ( typeof(add_response.id) !== 'undefined' && add_response.id )
        return add_response.id;
    else
        return 0;
}


const remove = async ( id = 0 ) => {
    let remove_response = await apiRequest(
                                            "/road-to-airport/types/delete/" + id,
                                            {
                                                method: "DELETE"
                                            },
                                            'ptp_client'
                                        );
    if ( typeof(remove_response.id) !== 'undefined' && remove_response.id )
        return remove_response.id;
    else
        return 0;
}


const getImageUrl = ( image_path = '' ) => {
    if ( String(image_path).trim() === '' || image_path.indexOf('http') === 0 )
        return image_path;
    return getSluiceUrl('ptp_client') + "/road-to-airport/files/" + image_path;
}


const RoadToAirportCategories = {
    list,
    add,
    update,
    remove,
    getImageUrl
};
export default RoadToAirportCategories;